export default "__VITE_ASSET__oLBwDfvy__"